import React from 'react';

const styles = {
  active:         'rgba(16,185,129,0.15) #10b981',
  in_use:         'rgba(59,130,246,0.15) #60a5fa',
  available:      'rgba(20,184,166,0.15) #2dd4bf',
  in_repair:      'rgba(245,158,11,0.15) #fbbf24',
  broken:         'rgba(239,68,68,0.15) #f87171',
  lost:           'rgba(239,68,68,0.15) #f87171',
  donated:        'rgba(168,85,247,0.15) #c084fc',
  eol:            'rgba(100,116,139,0.12) #64748b',
  disposed:       'rgba(100,116,139,0.12) #64748b',
  derecognized:   'rgba(239,68,68,0.12) #f87171',
  in_store:       'rgba(99,102,241,0.15) #818cf8',
  depreciated:    'rgba(249,115,22,0.15) #fb923c',
  critical:       'rgba(239,68,68,0.15) #f87171',
  high:           'rgba(249,115,22,0.15) #fb923c',
  medium:         'rgba(245,158,11,0.15) #fbbf24',
  low:            'rgba(16,185,129,0.15) #34d399',
  open:             'rgba(59,130,246,0.15) #60a5fa',
  in_progress:      'rgba(99,102,241,0.15) #818cf8',
  pending_review:   'rgba(245,158,11,0.15) #fbbf24',
  board_approval:   'rgba(124,58,237,0.18) #a78bfa',
  on_hold:        'rgba(245,158,11,0.15) #fbbf24',
  resolved:       'rgba(16,185,129,0.15) #34d399',
  closed:         'rgba(100,116,139,0.12) #64748b',
  pending:        'rgba(245,158,11,0.15) #fbbf24',
  completed:      'rgba(16,185,129,0.15) #34d399',
  cannot_repair:  'rgba(239,68,68,0.15) #f87171',
  warranty_claim: 'rgba(168,85,247,0.15) #c084fc',
  windows:        'rgba(59,130,246,0.15) #60a5fa',
  office:         'rgba(234,88,12,0.15) #fb923c',
  antivirus:      'rgba(16,185,129,0.15) #34d399',
  expired:        'rgba(239,68,68,0.15) #f87171',
  blacklisted:    'rgba(100,116,139,0.12) #64748b',
  resigned:       'rgba(100,116,139,0.12) #64748b',
  terminated:     'rgba(239,68,68,0.15) #f87171',
  offboarded:     'rgba(100,116,139,0.15) #94a3b8',
  initiated:      'rgba(59,130,246,0.15) #60a5fa',
  cancelled:      'rgba(100,116,139,0.15) #94a3b8',
  default:        'rgba(255,255,255,0.06) #64748b',
};

const ROLE_LABELS = {
  admin: 'Admin',
  it_staff: 'IT Staff',
  junior_it: 'Junior IT',
  director: 'Director',
  finance_staff: 'Finance Staff',
  general_user: 'General User',
};

export default function Badge({ value, label }) {
  const text = label || ROLE_LABELS[value] || String(value || '').replace(/_/g, ' ');
  const [bg, color] = (styles[value] || styles.default).split(' ');
  return (
    <span style={{ background: bg, color, border: `1px solid ${color}30`, padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: 500, textTransform: 'capitalize', whiteSpace: 'nowrap', display: 'inline-block' }}>
      {text}
    </span>
  );
}
